import React from 'react';
import { Card, CardHeader } from '@opendate-app/setlist';
import ReportingPageLayout from './ReportingPageLayout';
import useReportingPage from '../hooks/useReportingPage';
import '../styles/giftCardReports.css';

const REPORTS = [
  {
    key: 'gift_cards_liability',
    title: 'Liability',
    description: 'Money left on your gift cards at any date, by product, with how long balances have been outstanding.',
    path: (teamId) => `/teams/${teamId}/reporting/gift_cards/liability`,
  },
  {
    key: 'gift_cards_sales',
    title: 'Sales',
    description: 'Cards sold and issued, face value, fees and refunds by product and channel.',
    path: (teamId) => `/teams/${teamId}/reporting/gift_cards/sales`,
  },
  {
    key: 'gift_cards_redemptions',
    title: 'Redemptions',
    description: 'How much of your gift cards was used, by venue and event.',
    path: (teamId) => `/teams/${teamId}/reporting/gift_cards/redemptions`,
  },
  {
    key: 'gift_cards_ledger',
    title: 'Ledger',
    description: 'Changes to your gift card balances, ready to export for accounting.',
    path: (teamId) => `/teams/${teamId}/reporting/gift_cards/ledger`,
  },
];

function ReportingGiftCardsPage({ team }) {
  const {
    isMobile, sidebarOpen, setSidebarOpen,
    dateRange, setDateRange,
    filterSidebarOpen, setFilterSidebarOpen,
    activeFilters,
    handleFilterChange, handleRemoveFilter, handleClearAllFilters,
  } = useReportingPage('year_to_date');

  const teamId = team?.id;

  return (
    <ReportingPageLayout
      team={team}
      activeKey="gift_cards"
      title="Gift Cards"
      subtitle="Gift card liability, sales, redemptions and ledger reports for your organization."
      dateRange={dateRange}
      setDateRange={setDateRange}
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setSidebarOpen={setSidebarOpen}
      filterSidebarOpen={filterSidebarOpen}
      setFilterSidebarOpen={setFilterSidebarOpen}
      activeFilters={activeFilters}
      filterGroups={[]}
      handleFilterChange={handleFilterChange}
      handleRemoveFilter={handleRemoveFilter}
      handleClearAllFilters={handleClearAllFilters}
      showDatePicker={false}
      showFilters={false}
    >
      <div className="gift-card-reports-grid">
        {REPORTS.map((report) => {
          const open = () => { window.location.href = report.path(teamId); };
          return (
            <Card
              key={report.key}
              className="gift-card-report-card"
              role="link"
              tabIndex={0}
              aria-label={report.title}
              onClick={open}
              onKeyDown={(event) => { if (event.key === 'Enter') open(); }}
              header={<CardHeader title={report.title} supportingText={report.description} />}
            />
          );
        })}
      </div>
    </ReportingPageLayout>
  );
}

export default ReportingGiftCardsPage;
